var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', [!_vm.questions.length ? _c('v-sheet', {
    staticClass: "d-flex flex-column align-center justify-center"
  }, [_vm._v(" 추가질문답변이 없습니다. ")]) : [_c('v-sheet', {
    staticClass: "mt-n40 mt-lg-n60"
  }, _vm._l(_vm.questions, function (value, index) {
    return _c('question-item', _vm._b({
      key: value.question._id,
      staticClass: "mt-40 mt-lg-60",
      attrs: {
        "readonly": ""
      }
    }, 'question-item', {
      value: value,
      index: index
    }, false));
  }), 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }